import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=88d874ae&scoped=true"
import script from "./MessagesList.vue?vue&type=script&lang=ts"
export * from "./MessagesList.vue?vue&type=script&lang=ts"
import style0 from "./MessagesList.vue?vue&type=style&index=0&id=88d874ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d874ae",
  null
  
)

export default component.exports